// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__H0HPD","headerLogo":"logo_headerLogo__WfQdr","footerLogo":"logo_footerLogo__h3CDC"};